export default "__VITE_ASSET__DAvYvWyP__"